export { EloOnlineCourseIcon } from './online-course-icon'
